import type { FaireProductEntity } from "../../entity_types/product";

export const p_3j9pmss5hp: FaireProductEntity = {
  token: "p_3j9pmss5hp",
  type: "product",
  name: "Paper Cocktail Napkins Pack of 20 Rosanne Beck Mahjong",
  brandToken: "b_8cf036ajhp",
  brandName: "Boston International",
  imageUrl:
    "https://cdn.faire.com/fastly/0240d8e34d44d494230223ade5dba28029cd33ebe2e5b8b1104b66aec73d8f81.jpeg",
  galleryImageUrls: [],
  priceDollars: 2.85,
  description:
    "• Paper Cocktail Napkins Pack of 20 Mahjong Rosanne Beck\n• Dimensions and Misc info: 20 per pkg: 3 ply - 5 x 5 in.\n• Materials: Paper\n• Country of Origin: Germany\n• SKU: C045300",
  tags: [],
  msrpDollars: 5.7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:48.873Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
